import React from "react";
import { Info } from "lucide-react";
import { Helmet } from "react-helmet-async";

export default function AffiliateDisclosure() {
  return (
    <>
      <Helmet>
        <title>Affiliate Disclosure | Lo-Fee.com</title>
        <meta
          name="description"
          content="Our affiliate disclosure policy explains how Lo-Fee.com maintains transparency while providing unbiased Bitcoin exchange fee comparisons for Canadians."
        />
        <link rel="canonical" href="https://lo-fee.com/affiliate-disclosure" />
      </Helmet>

      <div className="max-w-4xl mx-auto px-6 py-12">
        <div className="space-y-8">
          <header className="space-y-4">
            <h1 className="text-4xl font-bold tracking-tight">
              Affiliate Disclosure
            </h1>
            <p className="text-lg text-[--text-secondary]">
              Transparency is important to us. Here's how we maintain our
              service while providing unbiased comparisons.
            </p>
          </header>

          <div className="bg-blue-50 border border-blue-200 p-6 rounded-lg">
            <div className="flex gap-4">
              <Info className="h-6 w-6 text-blue-500 flex-shrink-0" />
              <div className="space-y-2">
                <h2 className="text-lg font-bold text-blue-900">
                  Important Notice
                </h2>
                <p className="text-blue-800">
                  Lo-Fee.com may receive compensation from some of the exchanges
                  listed on this site. However, this does not influence our
                  comparisons or recommendations. All fees and rates shown are
                  accurate and updated in real-time.
                </p>
              </div>
            </div>
          </div>

          <section className="space-y-6">
            <h2 className="text-2xl font-bold">How We Make Money</h2>
            <div className="prose prose-lg max-w-none text-[--text-secondary]">
              <p>
                To maintain and improve our service, we participate in affiliate
                programs with some of the cryptocurrency exchanges listed on our
                site. This means:
              </p>
              <ul>
                <li>
                  We may receive a commission when users sign up through our
                  links
                </li>
                <li>
                  Affiliate relationships do not affect our fee calculations or
                  rankings
                </li>
                <li>
                  All fees and rates are pulled directly from exchange APIs
                </li>
                <li>
                  We clearly mark all affiliate links with an external link icon
                </li>
              </ul>
            </div>
          </section>

          <section className="space-y-6">
            <h2 className="text-2xl font-bold">Our Commitment to Users</h2>
            <div className="grid sm:grid-cols-2 gap-8">
              <div className="space-y-4 p-6 bg-[--bg-secondary] border-2 border-[--border-color]">
                <h3 className="text-lg font-bold">What We Promise</h3>
                <ul className="space-y-2 text-[--text-secondary]">
                  <li className="flex items-center gap-2">
                    <span className="text-green-500">✓</span> Accurate,
                    real-time data
                  </li>
                  <li className="flex items-center gap-2">
                    <span className="text-green-500">✓</span> Unbiased
                    comparisons
                  </li>
                  <li className="flex items-center gap-2">
                    <span className="text-green-500">✓</span> Transparent fee
                    calculations
                  </li>
                  <li className="flex items-center gap-2">
                    <span className="text-green-500">✓</span> Regular updates
                  </li>
                </ul>
              </div>
              <div className="space-y-4 p-6 bg-[--bg-secondary] border-2 border-[--border-color]">
                <h3 className="text-lg font-bold">What We Don't Do</h3>
                <ul className="space-y-2 text-[--text-secondary]">
                  <li className="flex items-center gap-2">
                    <span className="text-red-500">×</span> Manipulate rankings
                  </li>
                  <li className="flex items-center gap-2">
                    <span className="text-red-500">×</span> Hide or adjust fees
                  </li>
                  <li className="flex items-center gap-2">
                    <span className="text-red-500">×</span> Promote specific
                    exchanges
                  </li>
                  <li className="flex items-center gap-2">
                    <span className="text-red-500">×</span> Share user data
                  </li>
                </ul>
              </div>
            </div>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-bold">Questions?</h2>
            <p className="text-[--text-secondary]">
              If you have any questions about our affiliate relationships or how
              we maintain our independence, please don't hesitate to contact us.
            </p>
          </section>
        </div>
      </div>
    </>
  );
}
